// Parsing into JSON
export const parseJSON = <T>(value?: string): T | null => {
  try {
    return value ? (JSON.parse(value) as T) : null
  } catch {
    return null
  }
}
